export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img9-1f5e0814979521de37022323a60e4905.png";